import { useAppDispatch, useAppSelector } from "app/hooks"
import { useCallback, useEffect, useRef } from "react"
import {
  getRecentIngredients,
  resetRecentIngredients,
} from "../foodSlice"
import { useFailed } from "features/notification/hooks"

export const useRecentIngredients = () => {
  const recentIngredients = useAppSelector(
    (state) => state.food.recentIngredients,
  )
  const getRecentIngredientsLoading = useAppSelector(
    (state) => state.food.getRecentIngredientsLoading,
  )
  const getRecentIngredientsFailed = useAppSelector(
    (state) => state.food.getRecentIngredientsFailed,
  )
  const isNoRecentIngredients = useAppSelector(
    (state) => state.food.isNoRecentIngredients,
  )
  const hasMore = useAppSelector(
    (state) => state.food.hasMoreRecentIngredients,
  )
  const page = useAppSelector((state) => state.food.recentIngredientsPage)

  const dispatch = useAppDispatch()
  const isFirstLoad = useRef(true)

  const loadMore = useCallback(async () => {
    const currentPage = isFirstLoad.current ? 0 : page
    if (getRecentIngredientsLoading && currentPage !== 0) {
      return Promise.resolve()
    }
    isFirstLoad.current = false
    return await dispatch(getRecentIngredients({ page: currentPage + 1 }))
  }, [dispatch, getRecentIngredientsLoading, page])

  useFailed(getRecentIngredientsFailed)

  useEffect(() => {
    // Don't auto-fetch - InfiniteScroll handles initial load
    return () => {
      dispatch(resetRecentIngredients())
    }
  }, [])

  const reloadRecentIngredients = useCallback(() => {
    isFirstLoad.current = true
    loadMore()
  }, [loadMore])

  return {
    recentIngredients,
    getRecentIngredientsLoading,
    isNoRecentIngredients,
    loadMore,
    hasMore,
    reloadRecentIngredients,
  }
}
